import Phaser from 'phaser';

export const EVENTS = {
	SCENE_READY: 'laneChooserSceneReady',
	LOAD_WORLD: 'laneChooserLoadWorld',
	UPDATE_ROUND: 'laneChooserUpdateRound',
	INSTRUCTION_COMPLETE: 'laneChooserInstructionComplete',
	SKIP_INSTRUCTIONS: 'laneChooserSkipInstructions',
	SET_GAME_STARTED: 'laneChooserSetGameStarted',
	ANSWER_REQUESTED: 'laneChooserAnswerRequested',
	ANSWER_RESOLVED: 'laneChooserAnswerResolved',
	ROUND_EXIT_COMPLETE: 'laneChooserRoundExitComplete',
	SOUND_EFFECT: 'laneChooserSoundEffect',
	INSTRUCTION_TOOLTIP: 'laneChooserInstructionTooltip',
	INSTRUCTION_TOOLTIP_POS: 'laneChooserInstructionTooltipPos',
	QUESTION_IMAGE_PREVIEW: 'laneChooserQuestionImagePreview',
} as const;

export type LaneChooserEventBus = Phaser.Events.EventEmitter;

export const createLaneChooserEventBus = (): LaneChooserEventBus => new Phaser.Events.EventEmitter();
